export function composerExpanded(state: {
  focused: boolean;
  text: string;
  attachments: number;
  reply: boolean;
  error?: string | null;
}): boolean {
  return (
    state.focused || state.text.length > 0 || state.attachments > 0 || state.reply || Boolean(state.error)
  );
}

export const COMPOSER_ROW = 36;

export const COMPOSER_TALLEST = 200;

export function composerFieldHeight(content: number): number {
  if (!Number.isFinite(content)) return COMPOSER_ROW;
  return Math.max(COMPOSER_ROW, Math.min(COMPOSER_TALLEST, Math.ceil(content)));
}

export type ComposerKey = { key: string; shiftKey?: boolean };

export type KeyMeans = "next" | "previous" | "choose" | "dismiss" | "send" | "newline" | "type";

export function whatTheKeyDoes(press: ComposerKey, listOpen: boolean): KeyMeans {
  if (listOpen) {
    if (press.key === "ArrowDown") return "next";
    if (press.key === "ArrowUp") return "previous";
    if (press.key === "Enter" || press.key === "Tab") return "choose";
    if (press.key === "Escape") return "dismiss";
  }
  if (press.key !== "Enter") return "type";
  return press.shiftKey ? "newline" : "send";
}

export type ComposerButton = "microphone" | "send";

export function whatTheButtonIs(state: {
  coarse: boolean;
  text: string;
  attachments: number;
}): ComposerButton {
  if (!state.coarse) return "microphone";
  const anythingToSend = state.text.trim().length > 0 || state.attachments > 0;
  return anythingToSend ? "send" : "microphone";
}
